import ReactOnRails from 'react-on-rails';

import LoginPcApp from '../bundles/LoginPcApp/startup/LoginPcApp';
import WebPcApp from '../bundles/WebPcApp/startup/WebPcApp';

// This is how react_on_rails can see the WebPcApp in the browser.
ReactOnRails.register({
  WebPcApp, LoginPcApp
});



// WEBPACK FOOTER //
// ./app/javascript/packs/web-pc-app-bundle.js